module.exports = __webpack_public_path__ + "static/media/Origenes-logo-green.08fa09f3.svg";